import { FAQ } from '../core/faq';

export namespace FreelancersFAQ {
  export function onload(): void {
    FAQ.setup();
  }
}